import {
  SELECT_DOMAIN_FOR_CERTIFICATION,
  CURRENT_DOMAIN_FOR_CERTIFICATION,
  SELECT_COURSE_FOR_CERTIFICATION,
  CURRENT_CERTIFICATION_ID,
  SELECT_ACTIVE_SERVICE_DOMAIN,
  DELETE_SERVICE_DOMAIN,
  CLEAR_ALL_SERVICE_DOMAIN,
  REQUEST_SERVICE_DOMAIN,
  GET_RESPONSE_SERVICE_DOMAIN,
  ERROR_GET_RESPONSE,
  RESPONsE_SERVICE_DOMAIN,
  CLEAR_RESPONSE,
  SERVICE_DOMAIN_TAB,
  SERVICE_DOMAIN_TAB_RESET,
} from "./type";

export const selectDomainForCertification = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: SELECT_DOMAIN_FOR_CERTIFICATION,
      payload: payload,
    });
  } catch {
    dispatch({
      type: SELECT_DOMAIN_FOR_CERTIFICATION,
      payload: payload,
    });
  }
};

export const selectCourseForCertification = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: SELECT_COURSE_FOR_CERTIFICATION,
      payload: payload,
    });
  } catch {
    dispatch({
      type: SELECT_COURSE_FOR_CERTIFICATION,
      payload: payload,
    });
  }
};

export const currentDomainForCertification = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: CURRENT_DOMAIN_FOR_CERTIFICATION,
      payload: payload,
    });
  } catch {
    dispatch({
      type: CURRENT_DOMAIN_FOR_CERTIFICATION,
      payload: payload,
    });
  }
};

export const currentCertificationId = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: CURRENT_CERTIFICATION_ID,
      payload: payload,
    });
  } catch {
    dispatch({
      type: CURRENT_CERTIFICATION_ID,
      payload: payload,
    });
  }
};

export const fetchRequest = () => ({
  type: REQUEST_SERVICE_DOMAIN,
});

export const getActiveSrviceDomain = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: GET_RESPONSE_SERVICE_DOMAIN,
      payload: payload,
    });
  } catch {
    dispatch({
      type: GET_RESPONSE_SERVICE_DOMAIN,
      payload: payload,
    });
  }
};

export const handleErrorServiceDomain = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: ERROR_GET_RESPONSE,
      payload: payload,
    });
  } catch {
    dispatch({
      type: ERROR_GET_RESPONSE,
      payload: payload,
    });
  }
};

export const selectedActiveServiceDomain = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: SELECT_ACTIVE_SERVICE_DOMAIN,
      payload: payload,
    });
  } catch {
    dispatch({
      type: SELECT_ACTIVE_SERVICE_DOMAIN,
      payload: payload,
    });
  }
};

export const deleteServiceDomain = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: DELETE_SERVICE_DOMAIN,
      payload: payload,
    });
  } catch {
    dispatch({
      type: DELETE_SERVICE_DOMAIN,
      payload: payload,
    });
  }
};

export const clearAllServiceDomain = () => ({
  type: CLEAR_ALL_SERVICE_DOMAIN,
});

export const getResponseData = (payload) => async (dispatch) => {
  dispatch({
    type: RESPONsE_SERVICE_DOMAIN,
    payload: payload,
  });
};

export const clearResponse = () => ({
  type: CLEAR_RESPONSE,
});

export const setServiceDomainTab = (payload) => async (dispatch) => {
  dispatch({
    type: SERVICE_DOMAIN_TAB,
    payload: payload,
  });
};

export const clearServiceDomainTab = () => ({
  type: SERVICE_DOMAIN_TAB_RESET,
});
